<template>
<div class="container solarmap-wrapper" style="height:100%">
		  <template>
    <div>
	<!-- no-close-on-backdrop -->
<b-modal id="modal-2" centered title="Solkartan" v-model="showInfo" size="xl">
      <template #modal-header>
        <div class="text-center w-100">
		<b-img class="" src="./solkartan_logo.png"  alt="Solkartan" style="width:200px;max-width:100%"></b-img>
		
        </div>
      </template>
    <p><span class="span-mediumbig solar-bold">Information om Solkartan</span></p>
	<p>Solkartan kombinerar dina energianvändningsdata med PV -beräkningar för att hitta en lösning med kortast återbetalningstid.</p>

<p>Om du vill prova en annan lösning eller jämföra våra beräkningar med en annan är du fri att ändra nästan vilken parameter som helst och få nya beräkningar omedelbart.</p>

<p>Vid varje steg kan du klicka på <span class="solar-bold"><b-icon icon="question-circle" variant="dark" scale=1.2 shift-v="0" shift-h="0" class="mx-1"></b-icon></span> för att se beräkningsmetoder, antaganden och förslag på typiska värden.</p>

<p>När du är redo att ta nästa steg klickar du på ”Gå vidare med intresseanmälan”-knappen längst ner på sidan för att automatiskt överföra din analys till solteamet på Karlstads Energi.</p>

<p>
Egenkonsumtion beräknas med hjälp av en ny maskininlärningsmodell utvecklad av KTH och Karlstads Energi. (Ladda ner mastersavhandling <a href="http://kth.diva-portal.org/smash/get/diva2:1589293/FULLTEXT01.pdf" target="_blank">här</a>)
</p>

<p>
Ekonomiska beräkningar bygger på KTH-forskning. (Ladda ner doktorsavhandling <a href="http://kth.diva-portal.org/smash/get/diva2:1371035/FULLTEXT01.pdf" target="_blank">här</a>)
</p>

<p>
Karlstads kommun erbjuder kostnadsfri Energi- och klimatrådgivning finansierad av Energimyndigheten. (Läs mer <a href="https://karlstad.se/Miljo-och-Energi/klimat-och-energi/energi--och-klimatradgivning/" target="_blank">här</a>)
</p>

<p>
I Energimyndighetens Solelportalen finns det ytterligare vägledning om solceller. (Läs mer <a href="https://www.energimyndigheten.se/fornybart/solelportalen/" target="_blank">här</a>)
</p>

<p>
Hos Elsäkerhetsverket kan du läsa mer om installation av solceller. (Läs mer <a href="https://www.elsakerhetsverket.se/privatpersoner/din-elanlaggning/bygga-och-renovera/installation-av-solceller/" target="_blank">här</a>)
</p>

<p>Nya solkartan utvecklades av Karlstads Kommun i samarbete med Karlstads Energi, KTH Energiteknik och Beteendelabbet med finansiering från Energimyndighetens Design för Energieffektiv Vardag program.</p></span>
<div><b-img class="mt-2 mb-4" src="./logobanner.png"  alt="Solkartan" style="maxwidth:800px;max-width:100%"></b-img></div>

<p>Nya Solkartan används för icke-kommersiell forskning av KTH för att förbättra kommunikationstekniker.</p>

<p>Synpunkter på Solkartan kan skickas till <a href="mailto:kartservice@karlstad.se">kartservice@karlstad.se</a></p>

<div class="text-center"></div>
      <template #modal-footer>
        <div class="text-center w-100">
          <b-button
            size="lg"
            class="button-rounded mappage-button"
			 @click="showInfo = !showInfo" 
          >
            Stäng
          </b-button>
        </div>
      </template>
</b-modal>
<b-modal id="modal-3-consent" centered title="Solkartan" v-model="showConsentModal" size="xl" no-close-on-backdrop>
      <template #modal-header sticky fixed>
        <div class="text-center w-100" sticky fixed>
		<b-img class="" src="./solkartan_logo.png"  alt="Solkartan" style="width:200px;max-width:100%"></b-img>
        </div>
      </template>
    <p><span class="span-mediumbig solar-bold">Välkommen till Karlstads nya solkarta!</span></p>

<p>Nu kan du enkelt hitta solcellsrekommendationer för ditt hem och testa designalternativ själv.</p>

<p>Nya solkartan utvecklades av Karlstads Kommun i samarbete med Karlstads Energi, KTH Energiteknik och Beteendelabbet med finansiering från Energimyndighetens Design för Energieffektiv Vardag program.</p></span>
<div><b-img class="mt-2 mb-4" src="./logobanner.png"  alt="Solkartan" style="maxwidth:800px;max-width:100%"></b-img></div>
  <p class="my-3"><label for="agree"><input id="agree" type="checkbox" value="agree" v-model="consent"/> Jag godkänner</label> <span v-b-modal.modal-really style="text-decoration:underline">användningsvillkoren</span></p>
  
  <b-modal id="modal-really" title="Villkor" ok-only>
    <p class="my-4"></p>
	<iframe
        style="border: 1px solid black; height: 220px; width: 95%;"
        src="//gi.karlstad.se/analytics/index.php?module=CoreAdminHome&action=optOut&language=sv&backgroundColor=&fontColor=&fontSize=12pt&fontFamily=Arial,sans-serif"
        ></iframe>

  </b-modal>
  <p class="my-3"><label for="agree2"><input id="agree2" type="checkbox" value="agree" /> Visa inte den här rutan igen</label></p>
<div class="text-center"></div>
      <template #modal-footer>
        <div class="text-center w-100">
          <b-button
            size="lg"
            class="button-rounded mappage-button"
			 @click="hideConsentModal()" 
			  :disabled="!consent"
          >
            Stäng
          </b-button>
        </div>
      </template>
</b-modal>
    </div>
</template>
<!--
<div class="row">
<div class="col-md-4 border">EN CELL</div>



<div class="col-12 col-md-4">

	<div class="row">
	<div class="col-6 col-md-12">KEY: </div>
	<div class="col-6 col-md-12">VALUE</div>

	</div>

</div>



<div class="col-md-4 border">EN CELL</div>

</div>
_-->
<!--

<div class="row">
    <div class="col-md-4">MENU
         <div class="col-sm-4 col-md-12">acccount</div>
         <div class="col-sm-4 col-md-12">transact</div>
         <div class="col-sm-4 col-md-12">details</div>
    </div>
    <div class="col-md-8">LIST</div>
</div>
<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 border">
          <ul>
            <li><a style="cursor: pointer;">Home</a></li>
            <li><a style="cursor: pointer;">Contact</a></li>
            <li><a style="cursor: pointer;">About Us</a></li>
          </ul>
        </div>
    <div class="row">
      <div class="menu">
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <ul>
            <li><a style="cursor: pointer;">Home</a></li>
            <li><a style="cursor: pointer;">Contact</a></li>
            <li><a style="cursor: pointer;">About Us</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" style="background-color: #FFCDD2">
        <p>The layout shifter pattern is the most responsive pattern, with multiple breakpoints across several screen widths. Key to this layout is the way content moves about, instead of reflowing and dropping below other columns. Due to the significant
          differences between each major breakpoint, it is more complex to maintain and likely involves changes within elements, not just overall content layout.</p>

      </div>
    </div>
	-->
<div class="text-center py-3 px-1" style="max-width:100%">
<!--<div style="position:relative;right:0;top:0;" @click="showInfo = !showInfo">Om solkartan-->
<!--
<div class="text-right">
<span><b-icon id="menuButton" icon="patch-question" scale="2" variant="warning" aria-hidden="true" @click="showInfo = !showInfo" class="mr-2 mt-2"></b-icon></span></div>
-->
       <b-row>
	   <b-col>
	   <b-img class="" src="./solkartan_logo.png"  alt="Solkartan" style="max-width:80%"></b-img>
	   <b-icon id="menuButton" icon="patch-question" scale="2" variant="warning" aria-hidden="true" @click="showInfo = !showInfo" class="ml-4 mr-2 mt-2"></b-icon>
	   </b-col>
	   </b-row>
	   <!--
<h2 class="text-center py-3 my-1 header">
Solkartan
</h2>
       -->
		<!--
<h2 class="text-center py-3 my-1" style="font-weight:bold"><span><b-icon icon="sun" scale="2" variant="secondary" aria-hidden="true"></b-icon></span>Solkalkylatorn</h2>
 --> <!--<div id="app-wrapper" style="width:100%;height:50vh;">-->
 </div>
<div>
</div>
  <div id="app-wrapper" style="background:white;">
  </div>
  <div style="visibility:hidden;height:0">
  <div id="app-wrapper2" style="background:white;height:225px;width:350px;">
  </div>
  </div>
<!--<div id="overlayWindow" style="margin-top:30px;width:100%;height:50%;position:absolute;left:0;z-index:1000;background:white;">-->
<div id="overlayWindow" style="">
<h5 class="span-big solar-bold" align-v="center" v-if="!mapData">Markera de takytor du vill använda</h5>
<h5 class="span-medium" align-v="center" id="mapData" v-html="mapData" v-else></h5>
<!--
<b-button variant="danger" v-on:click="clearSelection()">Rensa</b-button>
<b-button variant="primary" v-bind:disabled="mapData === ''" v-on:click="nextPage()">Gå vidare</b-button>
<b-button class="rounded px-4 mr-2" style="width:120px" variant="danger">Rensa</b-button>
-->


	  
	  
                        <b-row class="py-1 px-1" v-show="mapData" style="float:left">
                          <b-col sm="12">
          <div class="text-center px-0">
            <h5 class="span-mediumbig solar-bold">Ungefärlig årsförbrukning:
			<b-icon icon="question-circle" aria-hidden="true" id="tooltip-page1" scale=0.9 shift-v="5" shift-h="-2"></b-icon>
  <b-tooltip target="tooltip-page1" triggers="hover" placement="top"><div>
<p class="text-left">
En normal årsförbrukning för en villa är:<br>
5 000 kWh med fjärrvärme<br>
12 000 kWh med bergvärme<br>
20 000 kWh med direktel
</p></div></b-tooltip>

  </h5>
          </div>
                          </b-col>
                          <b-col sm="8">
						  <b-form-input type="range" id="rangeInput-usageRoot" v-model="$root.annualDemand" step="500" :min="2000" :max="30000" class="text-right"></b-form-input>
                          </b-col>
                          <b-col sm="4">
              <b-input-group>
                <b-form-input type="number" id="numberInput-usageRoot" v-model="$root.annualDemand" step="500" :min="2000" :max="30000" class="text-right pr-1"></b-form-input>
                <b-input-group-append>
                  <b-input-group-text>kWh</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
                          </b-col>
                        </b-row>



                        <b-row class="solarmap-buttons mt-2 text-center">
						<b-col class="text-center">  
<b-button class="button-rounded mr-2 mappage-button" v-on:click="clearSelection()">
<b-icon icon="x" scale="1.5" aria-hidden="true"></b-icon>
Rensa
</b-button>
<b-button id="continueButton" class="button-rounded mr-2 mappage-button" v-bind:disabled="mapData === ''" v-on:click="nextPage()">
<b-spinner v-if="busy" small type="grow" style="margin-bottom: 3px;"></b-spinner>
<b-icon v-if="!busy" icon="check" scale="1.5" aria-hidden="true"></b-icon>
Fortsätt
</b-button>
</b-col>
</b-row>
<!--
<b-button class="rounded px-4 mr-2" style="width:120px" variant="secondary">Rensa</b-button>
<b-button class="rounded mx-2 mappage-button" style="width:120px" v-bind:disabled="mapData === ''" variant="primary">Rensa</b-button>
<b-button class="rounded px-4 mx-2 mappage-button" v-bind:disabled="mapData === ''" variant="secondary">Fortsätt</b-button>
<b-button class="rounded px-4 mx-2 mappage-button" style="background:#E40614;width:120px" v-bind:disabled="mapData === ''" variant="secondary">Rensa</b-button>
<b-button class="rounded mx-2 mappage-button" style="background:#FFDE02;width:120px;color:black" v-bind:disabled="mapData === ''" variant="primary">Fortsätt</b-button>
-->
  <div>
    <b-overlay id="e" :show="show" :opacity="0.95" rounded="sm" fixed no-wrap style="z-index:1022;width:100%">
      <template #overlay>
        <div class="text-center">
<b-icon icon="brightness-high" animation="spin" variant="warning" font-scale="12" class="mb-4"></b-icon>
<!--<img src="./1Kj6.gif" class="mb-5" />-->
          <!--<b-icon icon="circle-fill" font-scale="5" animation="throb"></b-icon>-->
<b-progress :value="value" variant="warning" height="2rem" :striped="true" class="w-50 mb-2 text-center" style="margin-left:auto;margin-right:auto;"></b-progress>
<!--
<b-progress :value="value" variant="secondary" height="2rem" show-progress :animated="true"></b-progress>
<b-progress :value="value" variant="secondary" height="2rem"></b-progress>
-->
<!--
<b-icon icon="brightness-low" animation="spin" variant="warning" font-scale="12"></b-icon>
<b-icon icon="brightness-high" animation="spin" variant="warning" font-scale="12"></b-icon>
<b-icon icon="brightness-high-fill" animation="spin" variant="warning" font-scale="12"></b-icon>
<b-icon icon="compass" animation="spin" variant="warning" font-scale="12"></b-icon>
<b-icon icon="arrow-clockwise" animation="spin" font-scale="12"></b-icon>
<b-icon icon="gear" animation="spin" font-scale="12"></b-icon>
<b-icon icon="gear-wide" animation="spin" font-scale="12"></b-icon>
<b-icon icon="globe" animation="spin" font-scale="12"></b-icon>
<b-icon icon="hourglass" animation="spin" font-scale="12"></b-icon>
-->
          <span id="progress-label" class="span-medium solar-bold w-75">Beräknar ditt rekommenderade system...</span>
          <p><span class="span-small  w-75">Solkartan kombinerar dina energianvändningsdata med PV -beräkningar för att hitta systemet med kortast återbetalningstid.</span></p>
<!--
        <b-progress :max="max" height="2rem" :striped="true" show-progress :animated="true">
          <b-progress-bar :value="value" variant="success">
            <h5 v-if="value > 0">Loading</h5>
          </b-progress-bar>
        </b-progress>
-->
        </div>
      </template>
    </b-overlay>
  </div>
</div>
  </div>
</template>

<script>
export default {
  name: 'SolarMap',
  data() {
        return {
		clicks:0,
      timer: 0,
      value: 0,
      max: 180,
consent: false,
show: false,
showInfo: false,
showConsentModal: true,
		busy: false,
			roofs:[],
			lastAlert: 0,
			mapData: ''
		}
  },
  methods: {
    hideConsentModal() {
	this.showConsentModal = false;
	if(document.getElementById("agree2").checked){
		localStorage.hideModal = true;
	}
	},
    startTimer() {
      let vm = this;
      let timer = setInterval(function() {
        vm.value += 3;
        if (vm.value >= 180) clearInterval(timer);
      }, 50);
},
      nextPage() {
		  if(document.getElementById("mapData").innerHTML != ''){
		  this.clicks = this.clicks +1;
		  this.busy = true;
		  this.show = true;
this.value = 0;
this.startTimer();
      setTimeout(() => {
 this.busy = false; 
this.show = false; 
}, 3000)
        this.$emit('nextPage', this.roofs);
		  }
      },
      hideCalc() {
        this.$emit('hideCalc');
      },
  updateWindow: function(layer){
	  console.log(layer);
var features = layer.getSource().getFeatures();
if(features.length > 3){
if(Date.now() - this.lastAlert > 100){
alert("Du kan välja max 3 tak");
this.lastAlert = Date.now();
}
var id = features[3].getId();
this.origo.api().getSelectionManager().removeItemById(id);
features = features.slice(0,3);
}
this.roofs = features.map(feature => {
var returnedObj = feature.getProperties();
returnedObj.id = feature.getId();
return returnedObj;
});
if(features.length === 0){
this.mapData = '';
//document.getElementById("mapData").innerHTML = '';
} else {
this.mapData = features.length + ' tak. Totalt ' + features.reduce(this.summit, 0) + 'm<sup>2</sup><br />';
//document.getElementById("mapData").innerHTML = features.length + ' tak. Totalt ' + features.reduce(this.summit, 0) + 'm<sup>2</sup><br />';
}
document.getElementById("sidebarcontainer").style.display = 'none';
if(features.length === 0){
this.clearMap();

}
	  /*
var features = layer.getSource().getFeatures();
var roofs = features.map(feature => feature.getProperties());
console.log(layer.getSource().getFeatures());
console.log(features.length + ' tak på ' + features.reduce(this.summit, 0) + 'm<sup>2</sup><br /><span onclick="">Gå vidare!<span><br /><span onclick="this.clearSelection()">Rensa!<span>');
//document.getElementById("overlayWindowContent").innerHTML = features.length + ' tak på ' + features.reduce(summit, 0) + 'm<sup>2</sup><br /><span onclick="">Gå vidare!<span><br /><span onclick="clearSelection()">Rensa!<span>';
//document.getElementById("sidebarcontainer").style.display = 'none';
console.log(roofs);
if(features.length === 4){
console.log("features.length === 4");
console.log(window);
var id = features[3].getId();
this.origo.api().getSelectionManager().removeItemById(id);
window.alert("Du kan välja max 3 tak");
//this.clearSelection();
}
//window.vuesite.solarValues.vAnnualDemand = 10000;
*/
/*
console.log(this.origo.api().getSelectionManager().getUrval());
console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());
console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getExtent());
*/
},

	summit: function(total, feature) {
  return total + Math.round(feature.get('area_slope'));
},
	  clearSelection: function() {
    var newRelativePathQuery = window.location.pathname;
    history.pushState(null, '', newRelativePathQuery);
  //console.log(this.origo.api().getSelectionManager().getNumberOfSelectedItems());
  this.clearMap();
  //this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().un('change', function(){updateWindow(this)});
  //this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().clear();
  //this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().on('change', function(){updateWindow(this)});
  this.hideCalc();
//console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());
//console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().clear());
//console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer());
//console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').clear());
//console.log(this.origo.api().getSelectionManager().getUrval().clear());
},
	  clearMap: function() {
  //console.log(this.origo.api().getSelectionManager().getNumberOfSelectedItems());
  //console.log(this.origo.api().getSelectionManager());
  this.origo.api().getSelectionManager().clearSelection();
  if(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures().length > 0){
  this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').clear();
  };
  //this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').clear();
  //console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer());
  //console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource());
  //console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());
  //console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m'));
  //console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m'));
}
  },
	mounted: function(){
	var updateWindow = this.updateWindow;
		//var roofs = [];
		//var lastAlert = 0;
      this.origo.on('load', function (viewer) {
	  
      //var element = document.getElementById('awesomplete_list_1');
	  //console.log(element)
	  //if(element){
      //element.addEventListener('click', function () {
	  //console.log("clicked: 8");
	  //console.log(event);
          //event.experiment.trackGoal(clickElements[id]);
      //});
	  //}
	  
        var multiselect = Multiselect({toggleSelectOnClick:true});
        viewer.addComponent(multiselect);
		
    viewer.dispatch('toggleClickInteraction', {
      name: 'multiselection',
      active: true
    });
	viewer.getSelectionManager().createSelectionGroup('solarmap_05m', 'Herrhagen');
	//viewer.getSelectionManager().createSelectionGroup('byggnader_m_stats_outside', 'byggnader_1m');
	viewer.getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().on('change', function(){updateWindow(this)});
	//viewer.getSelectionManager().getUrval().get('byggnader_m_stats_outside').getSourceLayer().on('change', function(){updateWindow(this);console.log(this)});
    document.getElementById(viewer.getMain().getMapTools().getId()).style.display = 'none';
	
	
		const queryString = window.location.search;
console.log(queryString);
const urlParams = new URLSearchParams(queryString);

if(urlParams.has('roofs') && urlParams.has('mapExtent')){
const qRoofs = urlParams.get('roofs');
const mapExtent = urlParams.get('mapExtent');
var roofArray = qRoofs.split(';').filter(i => i);
//console.log(this.$root.$refs.SolarMap.origo.api());
console.log(mapExtent);
viewer.getMap().getView().fit(mapExtent.split(','), {padding:[100,100,100,100]});
viewer.getMap().once('rendercomplete', function(event) {
   console.log("now");
   viewer.getSelectionManager().clearSelection();
roofArray.forEach((roof) => {
var feature = viewer.getLayer('solarmap_05m').getSource().getFeatureById(roof);
/*
console.log(viewer.getLayer('solarmap_05m').getSource().getState());
console.log(viewer.getLayer('solarmap_05m').getSource());
console.log(viewer.getLayer('solarmap_05m').getSource().getFeatures());
console.log(roofArray[0]);
console.log(feature);
*/
//console.log(viewer.);
viewer.getSelectionManager().getUrval().get('solarmap_05m').addFeature(feature);
});
});
/*
new window.Origo.ui.Modal({
            title: 'Länk till karta',
            content: 'abc',
            target: vuesite.$root.$refs.SolarMap.origo.api().getId()
          })
*/
/*
console.log(viewer.getLayer('solarmap_05m').getSource().getState());
	var feature = viewer.getLayer('solarmap_05m').getSource().getFeatureById(roofArray[0]);
console.log(viewer.getLayer('solarmap_05m').getSource());
console.log(viewer.getLayer('solarmap_05m').getSource().getFeatures());
console.log(roofArray[0]);
console.log(feature);
console.log(viewer.getLayer('solarmap_05m').getSource().getState());
*/
/*
setTimeout(function(){
roofArray.forEach((roof) => {
//var feature = viewer.getLayer('solarmap_05m').getSource().getFeatureById(roof);
console.log(viewer.getLayer('solarmap_05m').getSource().getState());
console.log(viewer.getLayer('solarmap_05m').getSource());
console.log(viewer.getLayer('solarmap_05m').getSource().getFeatures());
console.log(roofArray[0]);
console.log(feature);
//console.log(viewer.);
//viewer.getSelectionManager().getUrval().get('solarmap_05m').addFeature(feature);
});
	
 }, 30);
*/
/*
var source = this.$root.$refs.SolarMap.origo2.api().getLayer('Vektorlager').getSource();

//map.getView().fit(searchResultSource.getExtent());
source.clear();
source.addFeatures(this.$root.$refs.SolarMap.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());
this.$root.$refs.SolarMap.origo2.api().getMap().getView().fit(source.getExtent(), {padding: [60,60,60,60]});
*/
/*
console.log(this.origo.api().getSelectionManager().getUrval());
console.log(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());
*/
console.log(qRoofs);
console.log(window);
window.vuesite.$root.annualDemand = urlParams.get('vAnnualDemand');
window.vuesite.$root.$refs.SolarMap.updateWindow(viewer.getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer());
setTimeout(function(){
window.vuesite.$root.$refs.SolarMap.$emit('loadSaved', this.roofs);
 }, 2000);
//$root.annualDemand = 6666;


	console.log("BLABLABLA");
	//this.$root.annualDemand = urlParams.get('vAnnualDemand');
	//this.nextPage();
	//this.updateWindow(this.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer());
	//this.$emit('nextPage', this.roofs);
}
//console.log(urlParams.has('roofs'));


	
      });
	  
	},
    created() {
    if (localStorage.hideModal) {
      this.showConsentModal = false; 	
    }
        this.$root.$refs.SolarMap = this;
	this.origo = Origo('./index.json', {target: '#app-wrapper', breakPoints: {
      xs: [0,0],
      s: [320, 320],
      m: [500, 500],
      l: [768, 500]
    }});
	this.origo2 = Origo('./minimap.json', {target: '#app-wrapper2'});
		//console.log(this);
		//console.log(this.$root);
		//console.log(this.$root.$refs.SolarCalc);
		
    },
    updated() {
    }
}
</script>

<style src="./style.css"></style>